import { render } from "./Trainings.vue?vue&type=template&id=1fcdf1f3&scoped=true"
import script from "./Trainings.vue?vue&type=script&lang=js"
export * from "./Trainings.vue?vue&type=script&lang=js"

import "./Trainings.vue?vue&type=style&index=0&id=1fcdf1f3&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcdf1f3"]])

export default __exports__